import React, { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import BillingData from "./BillingData";
import DirectDebit from "./DirectDebit";
import Meter from "./Meter";
import Navbar from "components/MI/Navbar";
import SuccessRegister from "./SuccessRegister";
import UserMenu from "components/layout/userMenuNew";
import api from "services/api";
import {
  registerValuesNewUnit,
  resetStateNewUnit,
} from "store/actions/add-new-unit-actions";

import { Container, Header, Hr, Scrollbar, Title } from "./styles";

const RetonarUnidade = (): JSX.Element => {
  const { selectedUnit, addNewUnitReducer } = useSelector(
    // @ts-ignore
    (state) => ({
      // @ts-ignore
      selectedUnit: state.selectUnitReducer.selectedUnit,
      // @ts-ignore
      addNewUnitReducer: state.addNewUnitReducer,
    })
  );
  const dispatch = useDispatch();

  const { step } = addNewUnitReducer;

  const requestUserInfo = useCallback(async () => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const response = await api.get(`industrial/customer/v1/customers/me`, {
      headers,
    });

    const { data } = response;

    localStorage.setItem("@UltragazEmpresarial:loginEmail", data.email);

    return data;
  }, [api]);

  useEffect(() => {
    const address = selectedUnit?.address?.filter((add) => {
      return add?.addressType === "SHIP_TO";
    })[0];
    const addressShipLetterTo = selectedUnit?.address?.filter((add) => {
      return add?.addressType === "SHIP_LETTER_TO";
    })[0];

    dispatch(
      registerValuesNewUnit({
        address,
        addressShipLetterTo,
        unitInstanceId: selectedUnit?.instanceId,
        name: selectedUnit?.name,
        condominiumName: selectedUnit?.condominiumName,
      })
    );
    requestUserInfo();

    return () => {
      dispatch(resetStateNewUnit());
    };
  }, []);

  const buildComponent = useMemo(() => {
    return (
      {
        1: <Meter />,
        2: <BillingData />,
        3: <DirectDebit />,
        4: <SuccessRegister />,
      }[step] || <Meter />
    );
  }, [step]);

  return (
    <Navbar selected="retornar-unidade">
      <UserMenu />
      <Scrollbar>
        <Container>
          <Header>
            <Title>Retomar a titularidade da unidade</Title>
          </Header>

          <Hr />
          {buildComponent}
        </Container>
      </Scrollbar>
    </Navbar>
  );
};

export default RetonarUnidade;
